import Vue from 'vue';
import {
    getSwiper,
    getSwiperModules,
    handleClickOnDisclaimerLink,
} from '../utils';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/navigation';

Vue.component('homepage-thumb-slider', {
    props: [
        'totalSlides',
        'siteHandle',
        'disablePagination',
        'customSliderClass',
    ],

    data() {
        return {
            currentSlide: 0,
            gallery: null,
            slides: null,
        };
    },

    computed: {},

    mounted() {
        window.addEventListener('click', handleClickOnDisclaimerLink);
        this.initSwiper();
    },

    methods: {
        async initSwiper() {
            if (this.gallery) {
                // Update the existing swiper instance
                this.gallery.updateSlides();
                this.gallery.updateSize();
                this.gallery.updateProgress();
                this.gallery.updateSlidesClasses();

                // Force scrollbar update
                this.gallery.scrollbar.updateSize();
                this.gallery.scrollbar.init();
                this.gallery.scrollbar.setTranslate();

                // Force navigation update
                if (this.gallery.navigation) {
                    this.gallery.navigation.update();
                }
                this.gallery.update();
            } else {
                const { Swiper } = await getSwiper();
                const {
                    Autoplay,
                    Scrollbar,
                    Navigation,
                    Pagination,
                    A11y,
                    Keyboard,
                } = await getSwiperModules();

                const slider = this.$el.querySelector(
                    this.customSliderClass
                        ? `.${this.customSliderClass}`
                        : '.thumbslider__content',
                );

                this.gallery = new Swiper(
                    this.customSliderClass
                        ? `.${this.customSliderClass}`
                        : '.thumbslider__content',
                    {
                        modules: [
                            Autoplay,
                            Scrollbar,
                            Navigation,
                            Pagination,
                            A11y,
                            Keyboard,
                        ],
                        keyboard: {
                            enabled: true,
                        },
                        loopAdditionalSlides: 1,
                        loopAddBlankSlides: false,
                        slideActiveClass: 'swiper-slide-active',
                        watchSlidesProgress: true,
                        loop: true,
                        noSwiping: false,
                        centeredSlides: false,
                        slidesPerGroup: 1,
                        slidesPerView: 1.1,
                        spaceBetween: 16,
                        breakpoints: {
                            768: {
                                slidesPerView: 1.1,
                                spaceBetween: 32,
                            },
                            1024: {
                                slidesPerView: 1.1,
                                spaceBetween: 32,
                            },
                            1200: {
                                slidesPerView: 1.1,
                                spaceBetween: 32,
                            },
                            1400: {
                                slidesPerView: 1.1,
                                spaceBetween: 32,
                            },
                            1600: {
                                slidesPerView: 1.1,
                                spaceBetween: 32,
                            },
                            1800: {
                                slidesPerView: 1.1,
                                spaceBetween: 32,
                            },
                            2000: {
                                slidesPerView: 1.1,
                                spaceBetween: 32,
                            },
                            2200: {
                                slidesPerView: 1.1,
                                spaceBetween: 32,
                            },
                            2400: {
                                slidesPerView: 1.2,
                                spaceBetween: 32,
                            },
                            2600: {
                                slidesPerView: 1.4,
                                spaceBetween: 32,
                            },
                            2800: {
                                slidesPerView: 1.8,
                                spaceBetween: 32,
                            },
                            3000: {
                                slidesPerView: 2.2,
                                spaceBetween: 32,
                            },
                        },
                        scrollbar: {
                            el: '.swiper-scrollbar',
                            hide: false,
                            draggable: false,
                        },
                        uniqueNavElements: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        pagination: {
                            enabled: !Boolean(this.disablePagination),
                            el: slider.querySelector('.swiper-pagination'),
                            clickable: true,
                            renderBullet: (index, className) =>
                                `<span class="${className}"><span></span></span>`,
                        },
                    },
                )
                    .on('slideChange', (swiper) => {
                        this.currentSlide = swiper.activeIndex;
                    })
                    .on('sliderMove', () => {
                        this.addFullyVisibleClass();
                    })
                    .on('transitionEnd', () => {
                        this.addFullyVisibleClass();
                    })
                    .on('transitionStart', () => {
                        this.addFullyVisibleClass();
                    })
                    .on('resize', () => {
                        this.addFullyVisibleClass();
                    });

                Vue.nextTick(() => {
                    if (!this.gallery || !this.gallery.scrollbar) return;

                    this.gallery.scrollbar.updateSize();
                    this.gallery.scrollbar.setTranslate();
                });

                this.addFullyVisibleClass();
            }
        },

        slideTo(slide) {
            this.gallery.slideTo(slide);
        },

        addFullyVisibleClass() {
            const slides =
                this.slides ?? this.$el.querySelectorAll('.swiper-slide');

            // check if each slide is fully visible
            slides.forEach((slide) => {
                const slideRect = slide.getBoundingClientRect();
                const containerRect = this.$el.getBoundingClientRect();

                if (
                    slideRect.left >= containerRect.left &&
                    slideRect.right <= containerRect.right
                ) {
                    slide.classList.add('swiper-slide-fully-visible');
                } else {
                    slide.classList.remove('swiper-slide-fully-visible');
                }
            });
        },
    },
});
